import {
  parseTopicsArray,
  parseKeywordsArray,
  addSpeakersToSpeakerArray,
  parseWordsArray,
} from './utility';

const parse = (dataOriginal) => {
  const data = dataOriginal.media;

  let topics = [];
  let groups = [];
  let speakers = [];
  let transcript = [];
  let transcriptSpeakers = [];

  if (data.knowledge && data.knowledge.keywords && data.knowledge.keywords.words) {
    const { keywords, speakers: keywordSpeakers } = parseKeywordsArray(data.keywords.words);
    topics.push({
      name: 'ALL TOPICS',
      type: 'category',
      keywords,
      speakers: keywordSpeakers,
    });
    speakers = addSpeakersToSpeakerArray(speakers, keywordSpeakers);
  }

  if (data.keywords && data.keywords.groups) {
    const { topics: groupsArrayTopics, speakers: groupsArraySpeakers } =
      parseTopicsArray(data.keywords.groups);
    groups = groups.concat(groupsArrayTopics);
    speakers = addSpeakersToSpeakerArray(speakers, groupsArraySpeakers);
  }

  if (data.topics && data.topics.topics) {
    const { topics: topicsArrayTopics, speakers: topicsArraySpeakers } =
      parseTopicsArray(data.topics.topics);
    topics = topics.concat(topicsArrayTopics);
    speakers = addSpeakersToSpeakerArray(speakers, topicsArraySpeakers);
  }

  if (data.transcripts && data.transcripts.words) {
    const {
      words: wordsArrayWords,
      speakers: wordsArraySpeakers,
      transcriptSpeakers: wordsArrayTranscriptSpeakers,
    } =
      parseWordsArray(data.transcripts.words);
    transcript = transcript.concat(wordsArrayWords);
    speakers = addSpeakersToSpeakerArray(speakers, wordsArraySpeakers);
    transcriptSpeakers = wordsArrayTranscriptSpeakers;
  }

  return {
    activeTopic: 0,
    topics,
    activeGroup: 0,
    groups,
    activeSpeaker: 0,
    speakers,
    transcriptSpeakers,
    transcript,
    // TODO: Implement classifiers in v2 if required later.
    // They are mixed in with other predictions though which makes it hard.
    classifiers: null,
  };
};

export default parse;
